import React from 'react'
import NewPeriodPageComp from '../components/NewPeriodPageComp'

const NewClassroom = () => {
  return <NewPeriodPageComp />
}

export default NewClassroom
